import { Box, Spacer, TextNew } from '@jfs/ui-new'
import * as React from 'react'

export interface LabeledComponentTypes {
  leftTextLabel: string
  fieldName: string
  setFieldValue?: (fieldName: string, val: string | number) => void
  maxLength: number
  value?: string
  component: React.ElementType
  minWidth: number
}

const LabeledComponent = (props: LabeledComponentTypes): React.ReactElement => {
  const textLabel = props?.leftTextLabel
  const Component = props?.component
  const minWidth = props?.minWidth
  return (
    <Box pl={'6%'} mt={5}>
      <Box flexDirection="row">
        <Box justifyContent="center" minWidth={150}>
          <TextNew type="body12" color="BLACK_21" fontWeight="bold">
            {textLabel}
          </TextNew>
        </Box>
        <Spacer direction="horizontal" size={40} />
        <Box w="20%" minWidth={minWidth ?? 200}>
          <Component {...props} />
        </Box>
      </Box>
    </Box>
  )
}

export { LabeledComponent }
